module.exports = __webpack_public_path__ + "img/dice-d8.4dc14b27.svg";